import React, { Component } from 'react';
import IndexPage from './Components/Pages/Nav/IndexPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './Reducers/actions.js';
import { ThemeProvider } from '@material-ui/core/styles';
import FlagstoneTheme from './Config/flagstoneTheme';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ApiHelper from './Helpers/apiHelper';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      appSettings: null,
      ready: false
    }
  }

  componentDidMount = () => {
    fetch("appsettings.json", {
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then(
      function (res) {
        return res.json()
      }).then((data) => {
        console.log(data)
        this.setState({ appSettings: data })
        ApiHelper.appSettings = data
        this.setState({ ready: true })
      }).catch(
        function (err) {
          console.log(err, ' error')
        }
      )
  }

  render() {
    return (
      <ThemeProvider theme={FlagstoneTheme}>
        {this.state.ready &&
          <React.Fragment><Router basename={`${process.env.PUBLIC_URL}`}>
            <IndexPage {...this.props} appSettings={this.state.appSettings}></IndexPage>
          </Router>
            <ToastContainer /></React.Fragment>
        }
      </ThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  nav: state.nav,
  crud: state.crud,
  workstation: state.workstation,
  planning: state.planning,
  dashboard: state.dashboard
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(withTranslation(), connect(
  mapStateToProps,
  mapDispatchToProps
))(App);
